import { Avatar, Button, Card, CardContent, Stack, Typography } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ExcelImportDialog } from "./excel-import-dialog"

export function ImportExcelSelectedFile({ fileName, onFileSelect }) {
    const fileSelector = useDialog(<ExcelImportDialog />)

    return (
        <Card sx={{ backgroundColor: "background.neutral", boxShadow: 0 }}>
            <CardContent>
                <Stack spacing={3}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 600, lineHeight: 2.25, color: "text.primary" }}>
                        Uploading File
                    </Typography>
                    <Stack
                        direction="row"
                        sx={{
                            backgroundColor: "background.paper",
                            justifyContent: "space-between",
                            alignItems: "center",
                            height: 64,
                        }}
                        paddingX={2}
                    >
                        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
                            <Avatar>
                                <Iconify icon="mdi:file-document-outline" />
                            </Avatar>
                            <Typography variant="body2" data-cy="assets-selected-file-label">
                                {fileName || "No file selected"}
                            </Typography>
                        </Stack>
                        <Button
                            startIcon={<Iconify icon="ic:round-sync" />}
                            onClick={handleChangeFile}
                            data-cy="assets-import-excel-button"
                        >
                            Change File
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    async function handleChangeFile() {
        const result = await fileSelector()
        if (result?.files?.length > 0) {
            const selectedFile = result.files[0]
            onFileSelect(selectedFile)
        }
    }
}
